<template lang="pug">
.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            :data='tableData',
            @sort-change='sortChangeRequest'
        )
            el-table-column(
                prop='codigo',
                :label='$t("mensagens.laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='situacao',
                :label='$t("mensagens.laudos.situacao")',
                sortable='custom',
                align='left'
            )
                .template(slot-scope='scope')
                    div(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(
                v-if='showAnalystColumns',
                prop='status',
                :label='$t("mensagens.laudos.status")',
                sortable='custom',
                align='left'
            )
                .template(slot-scope='scope')
                    div(
                        v-if='scope.row.status && scope.row.situacao.codigo === "PROCESSADO"',
                        :class='["situacao", scope.row.status.codigo === "CONFORME" ? "conforme" : "nao-conforme"]'
                    ) {{ scope.row.status.codigo === 'CONFORME' ? $t('mensagens.laudos.conforme') : $t('mensagens.laudos.naoConforme') }}

            el-table-column(
                v-if='!showAnalystColumns',
                prop='informacaoLaudo.nomeTerritorio',
                :label='$t("mensagens.laudos.territorio")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='!showAnalystColumns',
                prop='informacaoLaudo.nomeRepresentante',
                :label='$t("mensagens.laudos.emitente")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='!showAnalystColumns',
                prop='informacaoLaudo.nomeCredor',
                :label='$t("mensagens.laudos.credor")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioAnaliseNome',
                :label='$t("mensagens.laudos.analistaResponsavel")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("mensagens.laudos.empresa")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("mensagens.laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("mensagens.laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
            el-table-column(
                v-if='!showAnalystColumns',
                prop='situacao',
                :label='$t("mensagens.laudos.situacao")',
                sortable='custom',
                align='left'
            )
                .template(slot-scope='scope')
                    div(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(
                v-if='!showAnalystColumns',
                prop='status',
                :label='$t("mensagens.laudos.status")',
                sortable='custom',
                align='left'
            )
                .template(slot-scope='scope')
                        div(
                            v-if='scope.row.status && scope.row.situacao.codigo === "PROCESSADO"',
                            :class="['situacao', scope.row.status.codigo === 'CONFORME' ? $t('mensagens.laudos.conforme') : $t('mensagens.laudos.inconforme')]"
                        ) {{ scope.row.status ? scope.row.status.nome : '-' }}

            el-table-column(
                :label='$t("mensagens.laudos.acoes")',
                align='left'
            )
                .template.d-flex.justify-content-left(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-if='!showAnalystColumns',
                                icon='el-icon-view',
                                @click.native='showModalVisualizacao(scope.row)'
                            ) {{ $t('mensagens.laudos.visualizarLaudo') }}
                            el-dropdown-item(
                                v-if='!showAnalystColumns && scope?.row?.situacao?.codigo === "NA_FILA"',
                                icon='el-icon-circle-close',
                                @click.native='showModalCancelarLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.cancelarLaudo') }}
                            el-dropdown-item(
                                v-if='!showAnalystColumns && scope.row.situacao.codigo === "PROCESSADO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('mensagens.laudos.baixarResultado') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope?.row?.situacao?.codigo !== "CANCELADO"',
                                icon='el-icon-upload',
                                @click.native='abreModalInserirResultado(scope.row)'
                            ) {{ $t('mensagens.laudos.enviarResultado') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope.row.situacao.codigo !== "CANCELADO"',
                                icon='el-icon-download',
                                @click.native='baixarDados(scope.row)'
                            ) {{$t('mensagens.laudos.baixarDados')}}
                            el-dropdown-item(
                                v-if='scope?.row?.situacao?.codigo === "CANCELADO" && showAnalystColumns',
                                icon='el-icon-minus'
                            ) {{ $t('mensagens.laudos.nenhumaAcao') }}
    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("mensagens.laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/services/LaudosService';
import UtilsService from '@/services/UtilsService';
import { mapState } from 'vuex';
import { classe } from '@/utils/laudoSituacao';

import EmptyResultLaudo from '@/components/laudos/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagem',
    components: {
        EmptyResultLaudo
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            classeSituacao: classe,
            idKeycloak: ''
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    created() {
        this.idKeycloak = this.usuarioLogado.idKeyCloack;
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(
                `mensagens.relatorioCompartilhamentoDeDados.${normalizedSituacao}`
            );
        },

        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            let params = {
                order: null,
                column: prop
            };

            if (column.order === 'ascending') {
                params.order = 'ASC';
            } else if (column.order === 'descending') {
                params.order = 'DESC';
            }

            this.$emit('laudoTecnicoAgricola:ordenar', params);
        },

        showModalVisualizacao(row) {
            this.$emit('laudoTecnicoAgricola:abrirModalVisualizacao', row.id);
        },

        showModalCancelarLaudo(row) {
            this.$store.dispatch('processarEventoGoogleAnalytics', {
                eventLabel: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                pageTitle: 'VISUALIZAR_MODAL_CANCELAMENTO_LAUDOS',
                routeName: this.$route?.name,
                routePath: this.$route?.path
            });
            this.$emit('handleModalCancelamento', row.id);
        },

        abreModalInserirResultado(row) {
            this.$emit(
                'laudoTecnicoAgricola:abrirModalInsercaoResultados',
                row
            );
        },

        async baixarDados(row) {
            try {
                await UtilsService.baixarArquivo(
                    `/laudo/${row.id}/shape/${this.idKeycloak}`
                );
                await this.atualizaStatus(row);
            } catch (error) {
            } finally {
                this.atualizarTabela();
            }
        },

        async atualizaStatus(row) {
            try {
                await LaudosService.atualizarStatusLaudo({
                    id: row.id
                });
            } catch (e) {}
        },

        atualizarTabela() {
            this.$emit('laudoTecnicoAgricola:atualizar');
        },

        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.laudos.downloadRealizadoComSucesso'
                        )
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.erroAoRealizarDownload'
                        )
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.el-table {
    .cell {
        word-break: break-word !important;
    }

    .action-button {
        cursor: pointer;
    }
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
    max-width: 150px;
}

.conforme {
    background-color: #d5f8d7;
    border: 1px solid #b0dcb3;
}

.nao-conforme {
    background-color: #f7d6da;
    border: 1px solid #e58585;
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
    display: flex;
    align-items: center;
}
</style>
